import React from "react";
import { useEffect,useContext,useState } from "react";
import { useTranslation } from 'react-i18next';
import { GlobalContext } from '../../GlobalContext';
import { methods } from '../../Validation';
import axios from 'axios';



    

const Body = () => {
   const { t, i18n } = useTranslation();
   const [back_end_error,setBack_end_error] = useState(null);
      const { default_country_detail } = useContext(GlobalContext);
           const { default_langage_details } = useContext(GlobalContext);
      const loader = document.getElementById("loder-tive");
       const [showThanks,setSetshowThanks] = useState(true);
              let default_country_detail_data = null;
    let default_language_detail_data =null;
    let country_detils =JSON.parse(localStorage.getItem('country_detils'));
  if(localStorage.getItem('defult_country_details') != null){
    default_country_detail_data = JSON.parse(localStorage.getItem('defult_country_details'));
    default_language_detail_data = JSON.parse(localStorage.getItem('defult_language_details'));
  }
       const [formData, setFormData] = useState({
           name: '',
           email: '',
           requestedDate:'',
           phoneNumber: '',
           pastor: '',
           churchLeader:' ',
           churchLeaderRole:'',
           churchName:'',
           churchAddress:'',
            countryId:default_country_detail.value
        
   
         });
           const [formdata_valid_error,setFormDatavalid] = useState({//validName
                 name: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:'The name field is required'}],required:true,error:false,errormsg:null
                 },
                 email: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:'The email field is required'},{keyname:'email',methods:'emailMethods',parmeters:[],errormag:"Please enter a valid email address"}],required:true,error:false,errormsg:null
                 },
                  requestedDate: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:'The Request Date field is required'}],required:true,error:false,errormsg:null
                 },
                 phoneNumber: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:'The phone field is required'}],required:true,error:false,errormsg:null},
                 pastor: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:'The pastor field is required'}],required:true,error:false,errormsg:null},
                 churchLeader:{validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:'The church leader field is required'}],required:true,error:false,errormsg:null},
                 churchLeaderRole:{validtion:[{parmeters:[],errormag:'The church leader role field is required'}],error:false,errormsg:null},
                 churchName: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:'The church name field is required'}],required:true,error:false,errormsg:null},
                 churchAddress: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:'The church Address  field is required'}],required:true,error:false,errormsg:null},
         
               });
          const [loading, setLoading] = useState(true);
           const [error, setError] = useState(null);
   const [cityoptions, setOptionData] = useState([]);
       const { siteName } = useContext(GlobalContext);
    
       let baseUrl = siteName.baseUrl;
       let defult_endpoint = siteName.training_endpoits;
       let webEndpoints = siteName.commonEndpoints;


       const handleChange = (e) => {
            const { name, value } = e.target;
           if(name == 'churchLeader'){
             let element = document.getElementById("churchLeader");
             console.log(value);
            if(value == 'true'){
                console.log('test')
                 element.classList.remove("d-none");
            }else{
              element.classList.add("d-none");
            }
           }
            if (name in formdata_valid_error) {
                if('validtion' in formdata_valid_error[name]){
               
                  let result = null;
                  let newformdata;
                    for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                        if (methods[formdata_valid_error[name].validtion[i].methods]) {
                            result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                            }
                       if(result == false){
                        formdata_valid_error[name].error = true;
                        formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                        newformdata = formdata_valid_error[name];
                         setFormDatavalid(prev => ({
                        ...prev,
                        [name]:newformdata
                        }));
                        break;
                       }
                       if(result == true){
                        
                          formdata_valid_error[name].error = false;
                        formdata_valid_error[name].errormsg = null;
                        newformdata = formdata_valid_error[name];
                         setFormDatavalid(prev => ({
                        ...prev,
                        [name]:newformdata
                        }));
                       }
    
                }
                
                }
                
     
            }
          
            setFormData(prev => ({
              ...prev,
              [name]: value
            }));
            console.log(formData)
          };

               const handleSubmit = (e) => {
                  e.preventDefault(); 
                  loader.classList.remove('d-none');
                  let value;
                  for (const name in formData) {
                      value = formData[name];
                      if (name in formdata_valid_error) {
                      if('validtion' in formdata_valid_error[name]){
                     
                        let result = null;
                        let newformdata;
                          for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                              if (methods[formdata_valid_error[name].validtion[i].methods]) {
                                  result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                                  }
                             if(result == false){
                              formdata_valid_error[name].error = true;
                              formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                              newformdata = formdata_valid_error[name];
                               setFormDatavalid(prev => ({
                              ...prev,
                              [name]:newformdata
                              }));
                              break;
                             }
                             if(result == true){
                              
                                formdata_valid_error[name].error = false;
                              formdata_valid_error[name].errormsg = null;
                              newformdata = formdata_valid_error[name];
                               setFormDatavalid(prev => ({
                              ...prev,
                              [name]:newformdata
                              }));
                             }
          
                      }
                      
                      }
           
                  }
                      }
          
                      let validation = true;
                       for (const key in formdata_valid_error) {
                          if(formdata_valid_error[key].error == true){
                             validation = false; 
                               loader.classList.add('d-none'); 
                             break;
                          }
                       }
          
                       if(validation){
                                     
                          console.log('Form submitted:', 'success');
                          console.log('Form submitted:', formData);
                          handleSubmit_axios(formData);
                          
                       }else{
                          loader.classList.add('d-none'); 
                          console.log('Form submitted:', 'faild');
                          console.log('Form submitted:', formData);
                       } 
                };

                const handleSubmit_axios = async (formData) => {
      
        try {
        //  const response = await axios.post(baseUrl+defult_endpoint+'register/student', formData);
 const token =  localStorage.getItem('token');
          let formdata_submit = formData
                 

            const response = await axios.post(baseUrl+'web/request/v1/training', formdata_submit,{
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
          let data = response;
          

          /*call back data*/
        setFormData({
             name: '',
           email: '',
           requestedDate:'',
           phoneNumber: '',
           pastor: '',
           churchLeader:'',
           churchLeaderRole:'',
           churchName:'',
           churchAddress:'',
            countryId:default_country_detail.value
   
         });
      if(data.status){
        setSetshowThanks(false);
          loader.classList.add('d-none'); 
      }
      //window.location.reload();
         
        } catch (error) {
          //setErrormsg(error.response.data.message);
            loader.classList.add('d-none'); 
          console.log(error.response.data);
              setBack_end_error(error.response.data.message);
          /*error call back*/
        }
      
    };

return (
       <section className="cfan-form-section">
        <div class="container">
       {showThanks? <form onSubmit={handleSubmit}>
            <div class="heading-form">
                <h3>{t('request_a_training')}</h3>
            </div>
            <div class="form-items-wrapper">
                    {back_end_error !=null? <div class="error">{back_end_error}</div> : ''}
                 <div class="form-intem">
                    <label for="fdate">{t('name')}{formdata_valid_error.name.required? <span>*</span> : ''}</label>
                    <input type="text" onChange={handleChange}  name="name" id="fdate" placeholder={t("name")} />
               {formdata_valid_error.name.error? <div className="error">{formdata_valid_error.name.errormsg}</div> : ''}
                </div>
                 <div class="form-intem">
                    <label for="fdate">{t('Email_Address')}{formdata_valid_error.email.required? <span>*</span> : ''}</label>
                    <input type="text" onChange={handleChange}  name="email" id="fdate" placeholder={t("Email_Address")} />
                  {formdata_valid_error.email.error? <div className="error">{formdata_valid_error.email.errormsg}</div> : ''}
                </div>
                  <div class="form-intem">
                    <label for="fdate">{t('Date')}{formdata_valid_error.requestedDate.required? <span>*</span> : ''}</label>
                    <input type="date" onChange={handleChange}  name="requestedDate" id="fdate" placeholder={t("Start_Time")} />
                  {formdata_valid_error.requestedDate.error? <div className="error">{formdata_valid_error.requestedDate.errormsg}</div> : ''}
                </div>
                 <div class="form-intem">
                    <label for="fdate">{t('Phone_number')}</label>
                    <input type="text" onChange={handleChange}  name="phoneNumber" id="fdate" placeholder={t("Phone_number")} />
                                       {formdata_valid_error.phoneNumber.error? <div className="error">{formdata_valid_error.phoneNumber.errormsg}</div> : ''}
                </div>
                 <div class="form-intem">
                    <label for="fdate">{t('pastor')}{formdata_valid_error.pastor.required? <span>*</span> : ''}</label>
                       <select name="pastor" onChange={handleChange}  id="pastor">
                       <option value="">{t("pastor")}</option>
                       <option value="true">{t("yes")}</option>
                        <option value="false">{t("no")}</option>
                    </select>
                      {formdata_valid_error.pastor.error? <div className="error">{formdata_valid_error.pastor.errormsg}</div> : ''}
                </div>
                
                   <div class="form-intem">
                    <label for="fdate">{t('churchLeader')}{formdata_valid_error.churchLeader.required? <span>*</span> : ''}</label>
                     <select name="churchLeader" onChange={handleChange} data-id="churchLeader"  id="pastor">
                       <option value="">{t("churchLeader")}</option>
                       <option value="true">{t("yes")}</option>
                        <option value="false">{t("no")}</option>
                    </select>
                       {formdata_valid_error.churchLeader.error? <div className="error">{formdata_valid_error.churchLeader.errormsg}</div> : ''}
                </div>
                   <div class="form-intem churchLeader d-none" id="churchLeader">
                    <label for="fdate">{t('churchLeaderRole')}{formdata_valid_error.churchLeaderRole.required? <span>*</span> : ''}</label>
                    <input type="text" onChange={handleChange}  name="churchLeaderRole" id="fdate" placeholder={t("churchLeaderRole")} />
                             {formdata_valid_error.churchLeaderRole.error? <div className="error">{formdata_valid_error.churchLeaderRole.errormsg}</div> : ''}
                    
                </div>
                   <div class="form-intem">
                    <label for="fdate">{t('churchName')}{formdata_valid_error.churchName.required? <span>*</span> : ''}</label>
                    <input type="text" onChange={handleChange}  name="churchName" id="fdate" placeholder={t("churchName")} />
                       {formdata_valid_error.churchName.error? <div className="error">{formdata_valid_error.churchName.errormsg}</div> : ''}
                </div>
                <div class="form-intem">
                    <label for="fdate">{t('churchAddress')}{formdata_valid_error.churchAddress.required? <span>*</span> : ''}</label>
                                    <textarea onChange={handleChange} value={formData.address} name="churchAddress"></textarea>
                                     {formdata_valid_error.churchAddress.error? <div className="error">{formdata_valid_error.churchAddress.errormsg}</div> : ''}  
                       
                </div>
                   <div class="form-intem">
                    <label for="country">{t("select_country")}</label>
                    <select name="countryId" onChange={handleChange}  id="countryId">
                       {country_detils.map((description, index) => (
                            <option
                              key={index}
                              value={description.value}
                            >
                              {description.label}
                            </option>
                          ))}
                    </select>
                     
                </div>
                
                <div class="form-intem form-item-full">
                    <button type="submit">{t("Submit")}</button>
                </div>
            </div>
        </form> : <div className="form-submit-success">
                              {t('New traning request submit successfully')}
                            </div>  }
    </div>
</section>
  );
};

export default Body;